"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importStar(require("react"));

var lib_1 = require("../lib");

var table_1 = require("../styled/table");

var makeOnTableKeyPress = function makeOnTableKeyPress(type) {
  switch (type) {
    case 'day':
      {
        return lib_1.handleDateKeyPress;
      }

    case 'month':
      {
        return lib_1.handleMonthKeyPress;
      }

    case 'year':
      {
        return lib_1.handleYearKeyPress;
      }

    case 'range':
      {
        return lib_1.handleRangeKeyPress;
      }
  }
};

var Table = function Table(_a) {
  var children = _a.children,
      date = _a.date,
      endDate = _a.endDate,
      label = _a.label,
      onSelect = _a.onSelect,
      onDateChange = _a.onDateChange,
      onEndDateChange = _a.onEndDateChange,
      type = _a.type; // (1) The table should get focus when the date field picker is showing.

  var _b = tslib_1.__read((0, react_1.useState)(), 2),
      tableElement = _b[0],
      setTableElement = _b[1];

  var tableRef = (0, react_1.useCallback)(function (node) {
    if (node !== null) {
      setTableElement(node);
    }
  }, []);
  (0, react_1.useEffect)(function () {
    return tableElement === null || tableElement === void 0 ? void 0 : tableElement.focus();
  }, [tableElement]); // (2) Handle keyboard navigation based on the type of the picker.

  var onTableKeyPress = function onTableKeyPress(event) {
    return makeOnTableKeyPress(type)({
      event: event,
      onSelectDate: onSelect,
      selectedDate: date !== null && date !== void 0 ? date : new Date(),
      selectedEndDate: endDate !== null && endDate !== void 0 ? endDate : new Date(),
      setSelectedDate: onDateChange,
      setSelectedEndDate: onEndDateChange !== null && onEndDateChange !== void 0 ? onEndDateChange : onDateChange
    });
  };

  return react_1.default.createElement(table_1.Table, {
    tabIndex: 0,
    role: "grid",
    "aria-label": label,
    onKeyDown: onTableKeyPress,
    ref: tableRef
  }, children);
};

exports.Table = Table;